import type { ReviewCreateInput } from "@ckgo2/shared/schemas";

/**
 * Převody editoru recenzí: detail z API → hodnoty formuláře a hodnoty formuláře → tělo
 * uložení. Čisté funkce bez Reactu (`reviewForm.test.ts`); stránka je předává `useEditPage`
 * jako `transformOnLoad` a `transformOnSave`.
 *
 * Na rozdíl od `guideForm.ts` převod detailu nevybírá zobrazená pole, ale rozprostře celý řádek:
 * tělo uložení je výstup resolveru `reviewSchema`, který neznámé klíče (`id`, `source`,
 * `createdAt`, `updatedAt`) zahodí, a výběr by tělo změnil, kdyby resolver někdy klíč nezahodil.
 */

/**
 * Detail z `GET /api/admin/reviews/:id`. D1 vrací u nevyplněných vazeb a textů `null`, ne
 * `undefined` (typ to neuvádí; převod proto čte vazby přes `||`). `updatedAt` čte `useEditPage`
 * z dat přímo (hlavička verze uložení), proto tu není.
 */
export interface ReviewDetail {
  id: string;
  tripId?: string;
  destinationId?: string;
  guideId?: string;
  customerName: string;
  customerLocation?: string;
  rating: number;
  title?: string;
  content: string;
  tripDate?: string;
  isFeatured: boolean;
  isVideo: boolean;
  videoUrl?: string;
  images?: string[];
  imageIds?: string[];
  isApproved: boolean;
}

/** Hodnoty nového formuláře recenze. */
export const REVIEW_FORM_DEFAULTS: ReviewCreateInput = {
  customerName: "",
  customerLocation: "",
  rating: 5,
  title: "",
  content: "",
  tripId: "",
  guideId: "",
  destinationId: "",
  isFeatured: false,
  isVideo: false,
  videoUrl: "",
  imageIds: [],
  isApproved: false,
};

/**
 * Detail → formulář: chybějící vazba je prázdný výběr (`""`), seznamy fotek pole a datum cesty
 * `Date` (vstup typu datum). Ostatní klíče řádku projdou beze změny.
 */
export function reviewFormFromDetail(r: ReviewDetail): ReviewCreateInput {
  return {
    ...r,
    tripId: r.tripId || "",
    guideId: r.guideId || "",
    destinationId: r.destinationId || "",
    images: r.images || [],
    imageIds: r.imageIds || [],
    tripDate: r.tripDate ? new Date(r.tripDate) : undefined,
  };
}

/**
 * Formulář → tělo uložení: prázdný výběr vazby a prázdná URL videa jsou `undefined`, takže
 * v JSON chybí (POST je neuloží, `PUT` přes `reviewSchema.partial()` sloupec nemění).
 */
export function reviewSaveBody(data: ReviewCreateInput) {
  return {
    ...data,
    tripId: data.tripId || undefined,
    guideId: data.guideId || undefined,
    destinationId: data.destinationId || undefined,
    videoUrl: data.videoUrl || undefined,
  };
}
